import { getTrackingApiUrl } from "./config";

const toRetryAfterMs = (value) => {
  const seconds = Number.parseInt(String(value || ""), 10);
  if (!Number.isFinite(seconds) || seconds <= 0) return null;
  return seconds * 1000;
};

const postJson = async (path, body, { keepalive = false } = {}) => {
  const baseUrl = getTrackingApiUrl();
  if (!baseUrl) return { ok: false, disabled: true, status: 0, retryAfterMs: null };

  try {
    const res = await fetch(`${baseUrl}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      keepalive,
    });

    const retryAfterMs = res.status === 429 ? toRetryAfterMs(res.headers.get("Retry-After")) : null;

    return {
      ok: res.ok,
      disabled: false,
      status: res.status,
      retryAfterMs,
    };
  } catch {
    return { ok: false, disabled: false, status: 0, retryAfterMs: null };
  }
};

export const postTrackingEvent = (event, options) =>
  postJson("/tracking/events", event, options);

export const postTrackingBatch = (payload, options) =>
  postJson("/tracking/events/batch", payload, options);

export const fetchVisitorCountry = async () => {
  const baseUrl = getTrackingApiUrl();
  if (!baseUrl) return { countryCode: null, countryName: null, continent: null };

  try {
    const res = await fetch(`${baseUrl}/tracking/visitor-country`, {
      method: "GET",
      headers: { "Accept": "application/json" },
    });

    if (!res.ok) {
      return { countryCode: null, countryName: null, continent: null };
    }

    const data = await res.json();
    return {
      countryCode: data?.countryCode ?? null,
      countryName: data?.countryName ?? null,
      continent: data?.continent ?? null,
    };
  } catch {
    return { countryCode: null, countryName: null, continent: null };
  }
};
